"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "firstname": "Nombre",
    "lastname": "Apellido paterno",
    "birthday": "Fecha de nacimiento",
    "email": "Email",
    "mobile": "Teléfono Móvil",
    "continue": "Continuar",
    "agree": "Acepto <a href=\"HREF\">el tratamiento de mis datos personales</a> y recibir publicidad y otros mensajes informativos",
    "validationErrorEmail": "Por favor, introduce tu correo electrónico válido",
    validationErrorPhone: "Ingresa tu número de teléfono válido",
    waitPageText: "La selecci\u00F3n de ofertas para tu perfil est\u00E1 en proceso. <br/><br/>\nQuedan 5 segundos."
};
